var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreesAlt9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9425 2.6538C16.3782 1.78206 17.6218 1.78207 18.0575 2.65381L20.8737 8.28832C21.2667 9.07473 20.6951 10 19.8162 10H19.4128L21.8421 14.8604C22.3334 15.8434 21.6188 17 20.5202 17H17.75V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H5.25V17.8859C3.39935 17.3155 2 14.6733 2 11.5C2 7.91015 3.79086 5 6 5C8.20914 5 10 7.91015 10 11.5C10 14.6733 8.60065 17.3155 6.75 17.8859V21.25H16.25V17H13.4798C12.3812 17 11.6666 15.8434 12.1579 14.8604L14.5872 10H14.1838C13.3049 10 12.7333 9.07472 13.1263 8.28832L15.9425 2.6538Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesAlt9);
export default __webpack_public_path__ + "static/media/trees-alt-9.33badda1cc3df07f608e1bd345fcfe36.svg";
export { ForwardRef as ReactComponent };